const syncUpdateReason = {
	name: 'Aktualisierung',
	fields: {
		sync_module: 'Modul',
		sync_entity_id: 'ERP-Nr.',
		entity: 'Datensatz',
		changed_columns: 'Geänderte Felder',
		changed_at: 'Zeitpunkt',
	},
}

export default syncUpdateReason
